import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../../../contexts/CurrentUser';
import {platformNamesMapping, platformMapping, availablePlatforms} from '../../../utils/platforms';

import './Filter.scss';


export const PlatformChooser = ({onChange, selected = []}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const workspaceConfig = currentUser?.workspace?.config;
  const availablePlatformsConfig = workspaceConfig?.available_platforms || [];

  let platformList = [];
    
  if (availablePlatformsConfig?.length > 0) {
    platformList = availablePlatformsConfig.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platform,
    }));
  }
  else {
    platformList = availablePlatforms.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platform,
    }));
  }

  const handleSelect = () => {
    if (platformList.length !== selected.length) {
      onChange(platformList.map(platform => platform.value))
    } else {
      onChange([])
    }
  }

  return(
    <div className='chooser'>
      <div className='control' onClick={() => handleSelect()}>{platformList.length === selected.length ? t('Deselect all') : t('Select all')}</div>
      <ul>
        {platformList.map(platform => {
          return(
            <li key={platform.value}>
              <input 
                id={`platform_${platform.value}`}
                type='checkbox'
                checked={selected.includes(platform.value)}
                onChange={() => {
                  if (selected.includes(platform.value)) {
                    onChange(selected.filter(v => v !== platform.value)) 
                  } else {
                    onChange([...selected, platform.value]) 
                  }
                }}
              />
              <label htmlFor={`platform_${platform.value}`}>{platform.name}</label>
            </li>
          )
        })}
        
      </ul>
    </div>
  )
}